var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { RequerimentoCNHEnum } from "@/models/Requerimento";
import { CircleCheck } from "lucide-react";
function Info(data) {
    return (_jsxs("div", __assign({ className: "flex sm:text-xl font-medium" }, { children: [_jsxs("span", __assign({ className: "mr-1" }, { children: [data.property, " "] })), _jsx("span", __assign({ className: cn(!(data === null || data === void 0 ? void 0 : data.contentTextMedium) && "font-light") }, { children: data.value }))] })));
}
export function CardNonProcess(_a) {
    var data = _a.data, CollapsableBtnDesktop = _a.CollapsableBtnDesktop, CollapsableBtnMobile = _a.CollapsableBtnMobile;
    var serviceName = data.codigoRequerimento === RequerimentoCNHEnum.NEGATIVA_CNH
        ? "NEGATIVA CNH"
        : "Permissão Internacional para Dirigir";
    var certidaoEmitida = data.codigoRequerimento === RequerimentoCNHEnum.NEGATIVA_CNH
        ? !!data.dataEmissaoCertidaoNegativa
        : !!data.dataEmissaoPid;
    var formataData = function (data) {
        if (!data)
            return "---";
        if (typeof data === "number") {
            data = data.toString();
        }
        var ano = data.slice(0, 4);
        var mes = data.slice(4, 6);
        var dia = data.slice(6, 8);
        return "".concat(dia, "/").concat(mes, "/").concat(ano);
    };
    return (_jsxs("div", __assign({ className: "flex sm:divide-x sm:divide-black-400 w-full max-w-[864px] p-6 bg-light-blue-100 border border-black-400 rounded-sm flex-wrap sm:flex-nowrap" }, { children: [_jsxs("div", __assign({ className: "flex flex-col justify-between w-full" }, { children: [_jsxs("div", { children: [_jsx(Info, { property: serviceName, value: "", contentTextMedium: true }), _jsx(Info, { property: "Situa\u00E7\u00E3o:", value: data.situacao })] }), _jsx(CollapsableBtnDesktop, {})] })), _jsxs("div", __assign({ className: "flex flex-col w-full sm:pl-4" }, { children: [_jsxs("div", __assign({ className: "flex sm:text-xl font-medium" }, { children: [_jsx("span", __assign({ className: "mr-1" }, { children: "Processo: " })), _jsx("span", __assign({ className: "font-light" }, { children: "".concat(data.codigoRequerimento, " - ").concat(data.descricaoRequerimento) }))] })), _jsx(Info, { property: "Data de in\u00EDcio:", value: formataData(data.dataProcesso) }), certidaoEmitida ? (_jsxs("div", __assign({ className: "flex sm:text-xl font-medium" }, { children: [_jsx("span", __assign({ className: "mr-1" }, { children: "Emissao Autorizada: " })), _jsx("span", __assign({ className: "flex justify-center items-center" }, { children: _jsx(CircleCheck, { className: "text-green-500 stroke-[2px]" }) }))] }))) : (""), _jsx(CollapsableBtnMobile, {})] }))] })));
}
